/**
 * LoyaltyLion simple components — theme glue (OCMSUPPORT-8285)
 *
 * The LoyaltyLion SDK is loaded by the app embed block, not by the theme.
 * This file only does three things:
 *
 *   1. Reveals [data-ll-points] wrappers once the SDK has actually written a
 *      number into them, so we never show "Earn  points" with a blank value.
 *   2. Re-runs loyaltylion.ui.refresh() when the PDP price changes (variant
 *      switch, swatch app) after re-reading the new price text.
 *   3. Exposes window.CatriceLoyalty.syncCart(cart) for the ajax mini cart,
 *      which updates [data-lion-points-for] to the new cart total and refreshes.
 *
 * Every SDK call is guarded, so nothing throws if LoyaltyLion loads late,
 * is blocked by an ad blocker, or is disabled entirely.
 */
(function () {
  'use strict';

  var REVEALED = 'll-points--ready';
  var fillWatcher = null;

  function refresh() {
    if (window.loyaltylion && window.loyaltylion.ui && typeof window.loyaltylion.ui.refresh === 'function') {
      window.loyaltylion.ui.refresh();
      return true;
    }
    return false;
  }

  /**
   * A wrapper is "ready" once its value span holds a non-empty string.
   * The SDK writes the number in as text, so a trimmed length check is enough.
   *
   * Also (re)attaches the fill watcher to any wrapper it hasn't seen yet. The
   * ajax mini cart replaces #mini_cart wholesale, which throws away the old
   * observers, so this has to be self-healing rather than run once on load.
   */
  function reveal() {
    var wrappers = document.querySelectorAll('[data-ll-points]');

    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      var value = wrapper.querySelector('.ll-points__value');
      var filled = value && value.textContent.replace(/\s/g, '').length > 0;

      // Sticky on purpose: refresh() momentarily blanks the span while it
      // re-renders, and hiding the line mid-refresh would make the layout
      // jump on every variant change. A fresh element (ajax mini cart) comes
      // back without the class, so it still starts hidden.
      if (filled) {
        wrapper.classList.add(REVEALED);
      }

      if (fillWatcher && !wrapper.hasAttribute('data-ll-watched')) {
        wrapper.setAttribute('data-ll-watched', '');
        fillWatcher.observe(wrapper, { childList: true, subtree: true, characterData: true });
      }
    }
  }

  /**
   * Point the cart components at a new total and re-render them.
   * `cart` is a /cart.js response; total_price is already in cents.
   */
  function syncCart(cart) {
    if (cart && typeof cart.total_price !== 'undefined') {
      var targets = document.querySelectorAll('[data-lion-points-for]');

      for (var i = 0; i < targets.length; i++) {
        targets[i].setAttribute('data-lion-points-for', cart.total_price);
      }
    }

    refresh();
    reveal();
  }

  window.CatriceLoyalty = {
    refresh: refresh,
    reveal: reveal,
    syncCart: syncCart
  };

  function init() {
    // The SDK boots asynchronously and fills the spans whenever it lands, so
    // watch for it rather than guessing at a timeout. reveal() attaches this
    // to each wrapper, including ones added later by the ajax mini cart.
    fillWatcher = new MutationObserver(reveal);

    reveal();
    initProductPrice();
  }

  /**
   * data-lion-price-for-product-id is read from the element's TEXT, so the SDK
   * has to be told to re-read it every time the theme rewrites the price.
   *
   * Two triggers, because two different things update that text:
   *   - the Slate product section fires jQuery "variantPriceChange" on the
   *     section container (assets/template.index@template.product.js)
   *   - the webyze swatch app writes the price directly
   * A MutationObserver on the price wrapper covers both, and the jQuery event
   * is kept as a cheap direct hook.
   */
  function initProductPrice() {
    // Only the wrapper that actually carries a LoyaltyLion price attribute;
    // other sections on the page use [data-price-wrapper] too.
    var priced = document.querySelectorAll('[data-lion-price-for-product-id]');
    if (!priced.length) return;

    var pending = null;

    function onPriceChange() {
      if (pending) clearTimeout(pending);

      // Debounced: a single variant change can rewrite the price node more
      // than once (price, then compare-at), and refresh() hits the network.
      pending = setTimeout(function () {
        pending = null;
        refresh();
        reveal();
      }, 120);
    }

    var priceObserver = new MutationObserver(onPriceChange);

    for (var i = 0; i < priced.length; i++) {
      priceObserver.observe(priced[i], {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    if (window.jQuery) {
      window.jQuery(document).on('variantPriceChange', onPriceChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
